import { useSuspenseQuery, useQueryClient } from '@tanstack/react-query';
import queryKeys from '../../support/uiStateKeys';

const dataKeys = [
  queryKeys.REMOVE_QUERY_ON_MODAL_CLOSE,
  queryKeys.FORM_VALIDATION_ERROR,
];
/**
 * useFormValidation returns formValidationError, setFormValidationError, and clearFormValidationError. FormValidationError is used to determine if the download button is disabled
 * if required fields are missing
 *
 * @returns {{ formValidationError: boolean, setFormValidationError: function }}
 */
const useFormValidationError = () => {
  const queryClient = useQueryClient();
  const { data } = useSuspenseQuery({
    queryKey: dataKeys,
    queryFn: ({ queryKey }) => queryClient.getQueryData(queryKey),
    initialData: false,
  });

  const setFormValidationError = (error) => {
    queryClient.setQueryData(dataKeys, error);
  };

  return {
    formValidationError: data,
    setFormValidationError,
  };
};

export default useFormValidationError;
